<template>
<b-row class="m-2">
    <b-col v-if="loaded === false">
         <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else>
        <b-row>
            <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>           
            <b-col>
                <h1>{{ecmResourceStrings.ttlOticRepoConfig}}</h1>
                <p>{{ecmResourceStrings.txtOticRepoInfoText}}</p>              
            </b-col>
             <b-col class="text-right OTbtnContainer" cols="4">
                 <otif-button class="OTPrimary"  @click.native="save" id="OTSaveSetting" :title="ecmResourceStrings.tipOticSaveConfig" style="margin-right:0.5rem" :disabled="$v.$dirty === false || $v.$invalid === true">{{ecmResourceStrings.lblSave}}</otif-button>
                <b-dropdown text="Actions" right class="OTtableRowDropdown">
                    <b-dropdown-item v-for="action in actions" @click="onAction(action)" :key="action.name">
                        <span :class="'ot-icon-' + action.id" />{{ action.label }}
                    </b-dropdown-item>
                </b-dropdown>
            </b-col>
        </b-row>
        <otif-select
            v-bind:label="ecmResourceStrings.lblDriver"
            v-model="$v.form.driver_type.$model"
            :required="false"
            :validation="$v.form.driver_type"
            :values="driver_types"
            @input="changeConnectivity($event)"
            :description="ecmResourceStrings.tipOticDriver"/>
        <otif-textInput
            v-bind:label="ecmResourceStrings.lblHostname"
            v-model="$v.form.host_name.$model"
            :validation="$v.form.host_name"
            v-bind:invalidMessage="ecmResourceStrings.msgHostnamerequired"
            :required="false"
            @input.native='onchange'
            :description="ecmResourceStrings.tipOticHostName"/>
        <otif-textInput
            v-bind:label="ecmResourceStrings.lblPort"
            v-model="$v.form.otic_port.$model"           
            v-bind:invalidMessage="ecmResourceStrings.msgPortrequired"
            :validation="$v.form.otic_port"
            @input.native='onchange'
            data-vv-validate-on="none"
            :description="ecmResourceStrings.tipOticPort"/>
        <otif-checkbox v-if="seen"
            v-model="form.sid"
            v-bind:label="ecmResourceStrings.lblUseSID"
            :required="false"
            :disabled="false"
            @input.native='onchange'
            :description="ecmResourceStrings.tipSID"/>
            <otif-textInput v-if="driverType === 'Oracle' && useSid === true" 
            v-bind:label="ecmResourceStrings.lblSID"
            v-model="$v.form.database_name.$model"
            v-bind:invalidMessage="ecmResourceStrings.msgSIDrequired"
            :validation="$v.form.database_name"
            @input.native='onchange'
            :description="ecmResourceStrings.tipOticSIDName"/>
            <otif-textInput v-else-if="driverType === 'Oracle' && useSid === false" 
            v-bind:label="ecmResourceStrings.lblServicename"
            v-model="$v.form.database_name.$model"
            v-bind:invalidMessage="ecmResourceStrings.msgServicenamerequired"
            :validation="$v.form.database_name"
            @input.native='onchange'
            :description="ecmResourceStrings.tipOticServiceName"/>
        <otif-textInput v-else
            v-bind:label="ecmResourceStrings.lblDatabasename"
            v-model="$v.form.database_name.$model"
            v-bind:invalidMessage="ecmResourceStrings.msgDatabasenamerequired"
            :validation="$v.form.database_name"
            :value='false'
            @input.native='onchange'
            :description="ecmResourceStrings.tipOticDBName"/>
         <otif-textInput
            v-model="$v.form.repo_connect_params.$model" 
            v-bind:label="ecmResourceStrings.lblConnectinformation"
            :required="false"
            :validation="$v.repo_connect_params"
            @input.native='onchange'
            :description="ecmResourceStrings.tipConnectInformation"/>
        <otif-textInput
            v-model="$v.form.user.$model"
            v-bind:label="ecmResourceStrings.lblDBuser"
            :validation="$v.form.user"
            v-bind:invalidMessage="ecmResourceStrings.msgDBuserrequired"
            @input.native='onchange'
            :description="ecmResourceStrings.tipDBUserName"/>
        <otif-passwordInput
            v-model="$v.form.password.$model"
            v-bind:label="ecmResourceStrings.lblDBpassword"
            :validation="$v.form.password"
            v-bind:invalidMessage="ecmResourceStrings.msgDBpasswordrequired"
            @input.native='onchange'
            :description="ecmResourceStrings.tipDBPassword"/>
        <otif-textInput
            v-model="$v.form.repositoryVersion.$model"
            v-bind:label="ecmResourceStrings.lblRepositoryverson"
            :validation="$v.form.repositoryVersion"
            v-bind:invalidMessage="ecmResourceStrings.msgRepoverrequired"
            @input.native='onchange'
            :description="ecmResourceStrings.tipOticRepoVersion"/>
        <otif-checkbox
            v-model="form.unicode"
            v-bind:label="ecmResourceStrings.lblUnicode"
            :required="false"
            @input.native='onchange'
            :description="ecmResourceStrings.tipOticUnicode"/>
        <otif-textInput
            v-model="$v.form.applicationVersion.$model"
            v-bind:label="ecmResourceStrings.lblApplicationversion"
            :validation="$v.form.applicationVersion"
            v-bind:invalidMessage="ecmResourceStrings.msgAppverrequired"
            @input.native='onchange'
            :description="ecmResourceStrings.tipOticAppVersion"/>
        <otif-textInput
            v-model="$v.form.oticUser.$model"
            v-bind:label="ecmResourceStrings.lblOTICUser"
            :validation="$v.form.oticUser"
            v-bind:invalidMessage="ecmResourceStrings.msgOTICUserrequired"
            @input.native='onchange'
            :description="ecmResourceStrings.tipOticUserName"/>
        <otif-passwordInput
            v-model="$v.form.oticPassword.$model"
            v-bind:label="ecmResourceStrings.lblOTICpassword"
            :validation="$v.form.oticPassword"
            v-bind:invalidMessage="ecmResourceStrings.msgOTICPasswordrequired"
            @input.native='onchange'
            :description="ecmResourceStrings.tipOticUserPassword"/>
        <otif-textInput
            v-bind:label="ecmResourceStrings.lblOTICprojectname"
            v-model="$v.form.oticProjectName.$model"
            :validation="$v.form.oticProjectName"
            v-bind:invalidMessage="ecmResourceStrings.msgOTICprjnamerequired"
            :required="false"
            @input.native='onchange'
            :description="ecmResourceStrings.tipOticProjectName"/>
        <otif-textInput
            v-bind:label="ecmResourceStrings.lblOTICprojectversion"
            v-model="$v.form.oticProjectVersion.$model"
            :validation="$v.form.oticProjectVersion"
            v-bind:invalidMessage="ecmResourceStrings.msgOTICprjverrequired"
            :required="false"
            @input.native='onchange'
            :description="ecmResourceStrings.tipOticProjectVersion"/>
        </b-col>
    </b-row>
</template>

<script>

import axios from 'axios';
import ECMErrorDialog from '../../modals/ECMCrawlerMessageDlg.vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { portbounders } from '../../../utils/validatorECM.js';
import { numericval } from '../../../utils/validatorECM.js';
import { showMessage } from '../../../utils/commonECM.js';

const defaultPorts = {
    'SQL':'1433',
    'Oracle': '1521',
    'PostgreSQL':'5432',
};

const defaultOticProjects = {
    'SQL':'MagellanECMCrawlerMSSQL',
    'Oracle': 'MagellanECMCrawlerOracle',
    'PostgreSQL':'MagellanECMCrawlerPostgreSQL',
};

export default {
    components: {
         ECMErrorDialog,
    },
    mixins: [ validationMixin ],

    data() {
        return {         
            seen: false,
            loaded: false,
            messageDlg: false,
            ecmResourceStrings: require('../../../utils/resourceECM.js'),   
            driver_types: [
               // 'SQL',
               // 'Oracle',
                'PostgreSQL'
            ],

            form: {
                driver_type: '',
                host_name: '',
                otic_port: '',
                database_name: '',
                sid:false,
                oticProjectVersion:'',
                oticProjectName:'',
                oticPassword:'*****',
                oticUser:'',
                applicationVersion:'',
                unicode:true,
                repositoryVersion:'',
                password:'*****',
                user:'',
                repo_connect_params:'',
            },
            actions: [{
                name: 'validate',
                label: 'Test Connection',
                callback: this.validate
            },{
                name: 'export',
                label: 'Export',
                callback: this.onExport
            },{
                name: 'import',
                label: 'Import',
                callback: this.onImport
            }],
        }
    },

    validations: {
        form: {
            driver_type: { required },
            host_name: { required },
            otic_port: { required, portbounders, numericval },
            database_name: { required },
            oticProjectVersion:{ required },
            oticProjectName:{ required },
            oticPassword:{ required },
            oticUser:{ required },
            applicationVersion:{ required },
            repositoryVersion:{ required },
            password:{ required },
            user:{ required },
            repo_connect_params: {  },
        }
    },

    computed: {
        /* these should be in computed area because if it's in watch area label of controls are not changed*/
        useSid:function()
        {
            const val =  this.form.sid;
            return val;
        },
        driverType: function ()
        {
            if(this.form.driver_type !== 'Oracle')
            {
                this.form.sid = false;
                this.seen = false;
            }
            else
            {
                this.seen = true;
            }
            const val =  this.form.driver_type;
            return val;
        },
    },

    methods: {
        onchange($e) {
            this.$v.$touch(true);
        },

        changeConnectivity(newVal) {
            this.$v.$touch(true);

            const defaultPort = defaultPorts[newVal];
            const defaultProjectName = defaultOticProjects[newVal];
            
            if(newVal !== 'Oracle')
            {
                this.form.sid = false;
                this.seen = false;
            }
            else
            {
                this.seen = true;
            }

            this.form.oticProjectName = defaultProjectName;
            this.form.otic_port = defaultPort;
        },

        onAction(action) {
            if (action.hasOwnProperty('callback')) {
                action.callback(action);
            }
        },

        validate(){
            this.$snotify.async(this.ecmResourceStrings.txtStartValidation, {
                timeout: 0
            });

            axios.get('/mtm-gateway-api/v1/services/ecm/config?fields=Tmp')
            .then((res) => {
                if (res.status == 200) {
                    this.$snotify.clear();
                    this.$snotify.success(this.ecmResourceStrings.txtOTICTestOk);
                }
            })
            .catch((err) => {
               this.showError(err, 'validate');
            });
        },  

        onExport(){
           this.$snotify.async(this.ecmResourceStrings.txtOTICRepoExportStart, {
                timeout: 0
            });
            var that = this;
            axios.get('/mtm-gateway-api/v1/services/ecm/CrawlerRepositories/OTIC')
            .then((res) => {
                if (res.data) {
                    const data = JSON.stringify(res.data)
                    const blob = new Blob([data], {type: 'text/plain'})
                    const e = document.createEvent('MouseEvents'),
                    a = document.createElement('a');
                    a.download = "etlcrawlerconfig.json";
                    a.href = window.URL.createObjectURL(blob);
                    a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
                    e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    a.dispatchEvent(e);
                    this.$snotify.clear();
            }})
            .catch((err) => {
                this.showError(err, 'get');
                this.$snotify.clear();
                this.$snotify.error(this.ecmResourceStrings.txtOTICRepoExportFail);
            });
        },

       onImport(){
           this.$router.push('/settings/oticrepository/oticrepositoryimport');
           return;
        },

        save() {
            this.$snotify.async(this.ecmResourceStrings.txtStartSaving);

            //prepare the string for save
            const host_name = this.form.host_name.trim();
            const port_num = this.form.otic_port.trim();
            const database_name = this.form.database_name.trim();
            const repo_connect_params = this.form.repo_connect_params.trim();
            const user = this.form.user.trim();
            const credo = this.form.password.trim();
            const repositoryVersion = this.form.repositoryVersion.trim();
            const unicode = this.form.unicode;
            const applicationVersion = this.form.applicationVersion.trim();
            const oticUser = this.form.oticUser.trim();
            const oticCredo = this.form.oticPassword.trim();
            const oticProjectName = this.form.oticProjectName.trim();
            const oticProjectVersion = this.form.oticProjectVersion.trim();
            const sid = this.form.sid;
            const driverChoosen = this.form.driver_type.trim();

            const databaseTypes = {
                'Oracle': 'jdbc:opentext:oracle://',
                'SQL':'jdbc:opentext:sqlserver://',
                'PostgreSQL':'jdbc:opentext:postgresql://'
            }

            const driverTypes = {
                'Oracle': 'opentext.genio.jdbc.oracle.OracleDriver',
                'SQL':'opentext.genio.jdbc.sqlserver.SQLServerDriver',
                'PostgreSQL':'opentext.genio.jdbc.postgresql.PostgreSQLDriver'
            }

            const connectivityTypes = {
                'Oracle': 'Oracle',
                'SQL':'MSSql',
                'PostgreSQL':'PostgreSQL'
            }

            //combine url string
            const additionalConn = repo_connect_params;
            const additionalConn1 = additionalConn.trim();
            var additionalConn2 = "";
            if(additionalConn1 != "")
            {
                //check if last is ;
                const stringLength = additionalConn1.length; 
                const lastChar = additionalConn1.charAt(stringLength - 1); // this will be the string "."
                if(lastChar != ";")
                {
                    const additionalConn3 = additionalConn1 + ";";
                    additionalConn2=";"+additionalConn3;
                }
                else
                {
                    additionalConn2=";"+additionalConn1;
                }
            }
               
            const driver =  driverTypes[driverChoosen];
            const connectivity =  connectivityTypes[driverChoosen];
            var url='';
            if(driverChoosen == 'Oracle')
            {
                if(port_num != null)
                {
                    if(sid == true)
                    {
                        url = databaseTypes[driverChoosen] + host_name + ':' + port_num + ';SID=' +  database_name + additionalConn2;
                    }
                    else
                    {
                        url = databaseTypes[driverChoosen] + host_name + ':' + port_num + ';ServiceName=' +  database_name + additionalConn2;
                    }
                }
                else
                {
                    if(sid == true)
                    {
                        url = databaseTypes[driverChoosen] + host_name + ';SID=' +  database_name + additionalConn2;
                    }
                    else
                    {
                        url = databaseTypes[driverChoosen] + host_name + ';ServiceName=' +  database_name + additionalConn2;
                    }
                }
            }
            else
            {   
                if(port_num != null)
                {
                    url= databaseTypes[driverChoosen] + host_name + ':' + port_num + ';databaseName=' +  database_name + additionalConn2;               
                }
                else
                {
                    url= databaseTypes[driverChoosen] + host_name + ';databaseName=' +  database_name + additionalConn2;
                }
            }

            var data = {
                'repositoryVersion': repositoryVersion,
                'unicode':unicode,
                'applicationVersion':applicationVersion,
                'oticUser':oticUser,
                'oticProjectName':oticProjectName,
                'oticProjectVersion': oticProjectVersion,
                'driver': driver,
                'url': url,
                'user':user,
                'connectivity':connectivity  };
                
            if(credo != "*****")
                data['password'] = credo;
            
            if(oticCredo != "*****")
                data['oticPassword'] = oticCredo;
            
            axios.put('/mtm-gateway-api/v1/services/ecm/CrawlerRepositories/OTIC', data)
            .then((res) => {
                this.$snotify.clear();
                this.$snotify.success(this.ecmResourceStrings.txtOticConfigSaved);
                this.$v.$reset();
             })
            .catch((err) => {
               this.showError(err, 'save');
            });
        },

        showError(err, location)
        {
            var sTitle='';
            var sError='';
            if(location === 'validate')
            {
                sTitle = this.ecmResourceStrings.ttlOticTestConnection;
                sError = this.ecmResourceStrings.errOticRepoValidate;
            }
            else if(location === 'save')
            {
                sTitle = this.ecmResourceStrings.ttlOticSaveConnection;
                sError = this.ecmResourceStrings.errOticRepoSave;
            }
            else if(location === 'create')
            {
                sTitle = this.ecmResourceStrings.txtError;
                sError = this.ecmResourceStrings.errOticRepoGet;
            }
            
            this.$snotify.clear();
            if(err.response)
            {
                if(err.response.data)
                {
                    this.$snotify.error(err.response.statusText, this.ecmResourceStrings.txtError, {
                        buttons: [
                            {text: this.ecmResourceStrings.txtViewDetails, action:()=>showMessage(this, 'error', sTitle, err.response.statusText, true, err.response.data), bold: true },
                        ],
                    });
                }
                else if(err.message)
                {
                    this.$snotify.error(err.response.statusText, this.ecmResourceStrings.txtError, {
                        buttons: [
                            {text: this.ecmResourceStrings.txtViewDetails, action:()=>showMessage(this, 'error', sTitle, err.response.statusText, true, err.message), bold: true },
                        ],
                    });
                }
                else
                {
                    this.$snotify.error(err.response.statusText, this.ecmResourceStrings.txtError, {
                        buttons: [
                            {text: this.ecmResourceStrings.txtViewDetails, action:()=>showMessage(this, 'error', sTitle, err.response.statusText, false, ''), bold: true },
                        ],
                    });
                }
            }
            else
            {
                this.$snotify.error(sError);
            }
        },
    },

    mounted() {
        var breadcrumbs = [{
            name: 'settings',
            meta: { label: 'Settings' }
        },{
            name: 'otic-settings',
            meta: { label: 'ETL Service' }
        }];

        this.$store.commit('breadcrumbs', breadcrumbs);
    },

    created() {
        var that = this;
        axios.get('/mtm-gateway-api/v1/services/ecm/CrawlerRepositories/OTIC')
        .then((res) => {
            that.form.oticProjectVersion = res.data.oticProjectVersion;
            that.form.oticProjectName = res.data.oticProjectName;
            //that.form.oticPassword = "*****";
            that.form.oticUser = res.data.oticUser;
            that.form.applicationVersion = res.data.applicationVersion;
            that.form.unicode = res.data.unicode;
            that.form.repositoryVersion = res.data.repositoryVersion;
            //that.form.password = "*****";
            //we are not care about connectivity 
            that.form.user = res.data.user;
                
            const driver =res.data['driver'];
            const url =res.data['url'];
            var connString="";
            const partsArray = url.split(';');
            const lenArr = partsArray.length;
            var databaseString = "";
            var busesid = false;
            for (var i=1;i<partsArray.length;i++) 
            {
                const c = partsArray[i].trim();
                if (c.indexOf("databaseName") > -1 || c.indexOf("SID") > -1 || c.indexOf("ServiceName")  > -1 || c.indexOf("DatabaseName") > -1)
                {
                    databaseString=c;
                    if (c.indexOf("SID") == 0)
                    {
                        busesid = true;
                    }
                }
                else
                {
                    if(c.length > 0)
                    {
                        const strTemp = c+";";
                        connString = connString +strTemp;
                    }
                }
            }
            const fullDriverName = partsArray[0];
            const tst = fullDriverName.split(':');
            var server = tst[3];
            const dbs = databaseString.split('=');
            const databaseName = dbs[1];
            const port =  tst[4];
            const drs = driver.split('.');
            const serverType = drs[4];
            if(server)
                server = server.substr(2);
            that.form.otic_port = port;
            that.form.host_name = server;
            that.form.database_name = databaseName;
            that.form.sid = busesid;
            that.form.repo_connect_params = connString;
            if(serverType == "OracleDriver")
            {  
                that.form.driver_type = 'Oracle';
            }
            else if(serverType == "PostgreSQLDriver")
            {
                that.form.driver_type = 'PostgreSQL';
            }
            else //sql
            {
                that.form.driver_type = 'SQL';
            }
            that.loaded = true;
            that.$v.$reset();
        })
        .catch((err) => {
            if(err.response.status == 406)
            {
                that.$snotify.info('Connection to Integration Center repository was not configured yet.');
            }
            else
            {
                that.showError(err, 'create');
            }
            that.loaded = true;
            that.$v.$reset();
        });
    },
}
</script>